import { useLocalStorage } from "../hooks/useLocalStorage";
import { PASSWORD_RESET_REQUIRED } from "./constants";

export const usePasswordResetRequired = () => {
  return useLocalStorage(PASSWORD_RESET_REQUIRED, false);
};
